import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
// import p1 from 'assests/Photos/LifeSkill2023/2024/CareerGuidance/1.jpg';
// import p2 from 'assests/Photos/LifeSkill2023/2024/CareerGuidance/2.jpg';
// import p3 from 'assests/Photos/LifeSkill2023/2024/CareerGuidance/3.jpg';
// import p4 from 'assests/Photos/LifeSkill2023/2024/CareerGuidance/4.jpg';
// import p5 from 'assests/Photos/LifeSkill2023/Roadsafty/5.jpg';
// import p6 from 'assests/Photos/LifeSkill2023/Roadsafty/6.jpg';
// import p7 from 'assests/Photos/LifeSkill2023/Roadsafty/7.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar2023 from 'views/LifeSkill2023/Sidebar2023';
import Archive2022 from '../LifeSkill2023/Archive2022';
import Sidebar2026 from '../LifeSkill2023/Sidebar2026';

const HandsCPRTraining2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  
  useEffect(() => {
    fetch('/config.json') // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/life-skill/HandsCPR/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/life-skill/HandsCPR/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/life-skill/HandsCPR/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/life-skill/HandsCPR/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/life-skill/HandsCPR/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/life-skill/HandsCPR/6.webp`;
  const p7 = `${config.base_image_url_2026}/home/events-activities/life-skill/HandsCPR/7.webp`;




  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1.2,
      cols: 1,
    },
    {
      src: p2,
      source:p2,
      rows: 1.2,
      cols: 1,
    },
    {
      src: p3,
      source: p3,
      rows: 1,
      cols: 1,
    },

    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },

    {
        src: p5,
        source: p5,
        rows: 1,
        cols: 1,
      },
        {
      src: p6,
      source: p6,
      rows: 1,
      cols: 1,
    },

    {
        src: p7,
        source: p7,
        rows: 1,
        cols: 1,
      },

  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
       “HANDS - ONLY CPR TRAINING FOR STUDENTS”
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Grade: 10 - 12          Date:15 September 2026
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        
Students of grades 10, 11 and 12 participated in an impactful and life-saving session on ‘Hands-Only CPR’ conducted by the Ramaiah Institute of Nursing Education and Research in the school campus. Under the expert guidance of the nursing faculty and professionals, the students learned the critical steps of recognizing a cardiac arrest, calling for emergency help and performing effective chest compressions without the complication of rescue breaths. Students learned crucial first-response steps for accident scenes—how to check for responsiveness and breathing, followed by administering chest compressions per minute to revive a patient. They actively practiced these techniques and the correct rhythm on manikins. 
        <br/>
        
By empowering high school students with this essential skill, the institute fostered a 
deep sense of civic duty, responsibility and preparedness among the youth. 
        <br/>
This session not only demystified emergency response for the students but also inspired them to become confident,
 responsible first responders within their schools and communities.
        <br/>
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
      ‘Saving a life is the most empowering skill a young mind can acquire.’

<br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <Sidebar2026/>
             </Box>
             <Box marginBottom={4}>
               <Archive2022/>
             </Box>

    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default HandsCPRTraining2026;